module.exports = __webpack_public_path__ + "static/tech-Icon-tool-08420e74368c8a6c8ef241f56d797917.png";